module.exports = __webpack_public_path__ + "static/media/10.36accad5.svg";